import {defineStore} from "pinia";

export const useMainStore = defineStore("main", {
    state: () => ({
        user: {
            id: null as string | null,
            first_name: null as string | null,
            last_name: null as string | null,
            nickname: null as string | null,
            email: null as string | null,
            country: null as string | null,
            organisation: null as string | null,
            involvement: null as string | null,
            roles: [],
            params: null as object | null,
            plan: null as {
                id: string;
                name: string;
                slug: string;
                description: string;
                price: number;
                stripe_price_id: string;
                is_active: boolean;
                group_limit: number;
                group_member_limit: number;
                post_limit: number;
                ai_tokens_limit: number;
                can_ask_detailed_questions: boolean;
                can_ask_annotation_questions: boolean;
                can_reuse_questions: boolean;
                can_export: boolean;
            } | null,
            pending_group_invitations_count: 0 as number,
            pending_contact_invitations_count: 0 as number,
            unread_conversations_count: 0 as number,
        },
        notifications: {
            updated_at: null as Date | null,
        },
        feed: {
            questions: [],
            params: {
                page: 0,
                sort: "created_at",
                filter: {
                    "question.groups.name": [],
                    "question.title": null,
                    type: [],
                },
            },
        },
        group: {
            questions: [],
        },
        groups: [] as Array<any>,
        selectedGroupId: null as string | null,
        launch: {
            user: null as string | null,
            questions: [] as Array<string>,
        },
        selectedQuestions: [] as Array<string>,
        messages: [] as Array<{
            text: unknown | string;
            type: "success" | "error";
            bag?: string;
        }>,
        show: {
            contact: null as string | null,
            expandedSidebar: false,
        },
        toastMessages: [] as Array<{
            severity: "success" | "info" | "warn" | "error";
            summary: string;
            detail?: string;
            life: number;
        }>,
        formSuccess: {},
        contacts: {
            state: {
                show: {
                    invitations: true,
                },
            },
        },
    }),
    getters: {
        $group(state) {
            return state.group;
        },
        selectedGroup(state) {
            return state.groups.find((g: any) => g.id === state.selectedGroupId) || null;
        },
    },
    actions: {
        addMessage(message) {
            message.id = new Date().getTime().toString() + Math.floor(Math.random() * 10000000).toString();
            this.messages.push(message);
        },
        incrementGroupInvitations() {
            this.user.pending_group_invitations_count++;
        },
        decrementGroupInvitations() {
            if (this.user.pending_group_invitations_count > 0) {
                this.user.pending_group_invitations_count--;
            }
        },
        incrementContactInvitations() {
            this.user.pending_contact_invitations_count++;
        },
        decrementContactInvitations() {
            if (this.user.pending_contact_invitations_count > 0) {
                this.user.pending_contact_invitations_count--;
            }
        },
        incrementUnreadConversations() {
            this.user.unread_conversations_count++;
        },
        decrementUnreadConversations() {
            if (this.user.unread_conversations_count > 0) {
                this.user.unread_conversations_count--;
            }
        },
        setUnreadConversations(count: number) {
            this.user.unread_conversations_count = Math.max(0, count);
        },
    },
});

export type MainStore = ReturnType<typeof useMainStore>;
